import React from 'react';
import Icon from '../../icons/Icon';
import NextStepsContent from '../../../content/NextStepsContent';

const NextSteps = () => {
    const renderItems = () => {
        const iconDefaultSize = '80px';
        const style = { backgroundColor: '#DBF3F5' };

        const itemsRendered = [];
        for (let i = 0; i < NextStepsContent.length; i++) {
            itemsRendered.push(
                <div className="app__grid__column__three-one padding-sides-20" key={i}>
                    <div className="app__how-it-works__icon">
                        <Icon
                            icon={NextStepsContent[i].icon}
                            size={iconDefaultSize}
                            style={style}
                        />
                    </div>
                    <div className="app__how-it-works__info font-lighter">
                        <span className="semi-bold">{i + 1}. </span>
                        <span dangerouslySetInnerHTML={{ __html: NextStepsContent[i].text }} />
                    </div>
                </div>
            );
        }
        return itemsRendered;
    };

    return (
        <div className="app__landing-page__section how-it-works">
            <div className="how-it-works__container">
                <div className="app__next-steps__list">{renderItems()}</div>
            </div>
        </div>
    );
};

export default NextSteps;
